import DIContainer from 'services/DIContainer';
import Mapper from './Mapper';
import { OrderDocumentResponseDTO } from 'typings/dto/orderDocument';
import UserUtils from 'utils/models/UserUtils';
import { UserResponseDTO } from 'typings/dto/user';
import DateWithTimezone from 'utils/implementations/DateWithTimezone';
import { TIME_ZONE } from 'typings/common/date.enum';

export default class OrderDocumentMapper extends Mapper<OrderDocument, OrderDocumentResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers, private statefulUtils: DIContainer.StatefulUtils) {
    super({
      name: 'name',
      technicalName: 'technicalName',
      status: 'status',
      attachments: 'attachments',
      createdBy: 'createdBy',
      signedTimestamp: 'signedTimestamp',
    });
  }

  public responseDTOToModel(dto: OrderDocumentResponseDTO, timezone?: TIME_ZONE): OrderDocument {
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      attachments: dto.attachments ? dto.attachments.map(this.subEntitiesMappers.file.responseDTOToModel_temp) : [],
      createdBy: UserUtils.mapUserResponseByType(dto.createdBy as UserResponseDTO, this.getOuterMappers()),
      signedTimestamp:
        dto.signedTimestamp && timezone
          ? new DateWithTimezone(dto.signedTimestamp, timezone, this.statefulUtils.date)
          : dto.signedTimestamp
          ? new Date(dto.signedTimestamp)
          : undefined,
    };
  }
}
